import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from './ServerService';

export interface TerminalSmartPos {
  id: number;
  nome: string;
  provedor: 'SIMULADOR' | 'STONE' | 'PAGBANK';
  situacao: 'ATIVO' | 'REVOGADO';
  terminalSerial: string | null;
  terminalModelo: string | null;
  versaoApp: string | null;
  vinculadoEm: string;
  vinculadoPor: {id: number; nome: string} | null;
  revogadoEm: string | null;
  revogadoPor: {id: number; nome: string} | null;
  motivoRevogacao: string | null;
  ultimoContatoEm: string | null;
}

export interface LicencasSmartPos {
  moduloAtivo: boolean;
  contratadas: number;
  emUso: number;
  valorMensalTerminal: number | null;
}

export interface PainelSmartPos {
  licencas: LicencasSmartPos;
  terminais: TerminalSmartPos[];
}

export interface CodigoVinculoSmartPos {
  codigo: string;
  nomeTerminal: string;
  expiraEm: string;
}

@Injectable({providedIn: 'root'})
export class SmartPosAdminService extends ServerService {
  constructor(http: HttpClient) { super(http); }

  obtenhaPainel(): Promise<PainelSmartPos> {
    return this.obtenha('/smartpos/admin/painel', {});
  }

  gereCodigo(nomeTerminal: string): Promise<CodigoVinculoSmartPos> {
    return this.facaPost('/smartpos/admin/codigos', {nomeTerminal});
  }

  revogue(id: number, motivo: string): Promise<TerminalSmartPos> {
    return this.facaPost(`/smartpos/admin/dispositivos/${id}/revogar`, {motivo});
  }
}
